// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__G-8j6"};